import React, { useState } from "react";
import { Box, TextField, Grid, Button } from "@mui/material";
import { addWarehouse } from "../Services/inventoryService";
import { enqueueSnackbar } from "notistack";
import { MSG_WAREHOUSE_ADDED } from "../Constants/MessageConstant";
import { SUCCESS } from "../Constants/LabelConstants";
import { IWarehouseFormData } from "../Interfaces/IWarehouse";



interface AddWarehouseFormProps {
  onSubmit?: (data: IWarehouseFormData) => void;
  onCancel?: () => void;
}

const AddWarehouseForm: React.FC<AddWarehouseFormProps> = ({ onSubmit, onCancel }) => {
  const [formData, setFormData] = useState<IWarehouseFormData>({
    warehouseName: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
    contactPerson: "",
    contactPhone: "",
    contactEmail: "",
  });
  const orgId = localStorage.getItem("orgId") || "";
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault(); // prevent page refresh
    try {
      const payload = {
        ...formData,
        orgID: orgId,
        createdBy: "AdminUser",
      };
  
      const res = await addWarehouse(payload);
  
      enqueueSnackbar(MSG_WAREHOUSE_ADDED, { variant: SUCCESS });
  
      // optional: call parent callback
      onSubmit?.(formData);
      // clear form after save
      setFormData({
        warehouseName: "",
        address: "",
        city: "",
        state: "",
        pincode: "",
        contactPerson: "",
        contactPhone: "",
        contactEmail: "",
      });
    } catch (err: any) {
      enqueueSnackbar(err.message || "Failed to add warehouse", { variant: "error" });
    }
  };
  

  return (
    <>
    <div className="page-location">
    <span>Master &gt; Warehouse Master</span>
  </div>
    <Box component="form" onSubmit={handleSubmit} sx={{ p: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            label="Warehouse Name"
            name="warehouseName"
            fullWidth
            required
            value={formData.warehouseName}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Address"
            name="address"
            fullWidth
            required
            multiline
            rows={2}
            value={formData.address}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            label="City"
            name="city"
            fullWidth
            required
            value={formData.city}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            label="State"
            name="state"
            fullWidth
            required
            value={formData.state}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            label="Pincode"
            name="pincode"
            fullWidth
            required
            value={formData.pincode}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            label="Contact Person"
            name="contactPerson"
            fullWidth
            value={formData.contactPerson}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            label="Contact Phone"
            name="contactPhone"
            fullWidth
            value={formData.contactPhone}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            label="Contact Email"
            name="contactEmail"
            type="email"
            fullWidth
            value={formData.contactEmail}
            onChange={handleChange}
          />
        </Grid>
      </Grid>

      <Box display="flex" justifyContent="flex-end" mt={2}>
        {onCancel && (
          <Button onClick={onCancel} sx={{ mr: 2 }}>
            Cancel
          </Button>
        )}
        <Button type="submit" variant="contained">
          Save
        </Button>
      </Box>
    </Box>
    </>
  );
};

export default AddWarehouseForm;
